import styled from 'styled-components'

import theme, { style } from 'theme'
import { PasswordInputV4 } from '@acorns/web-components'

export const HeroHeader = styled.div`
  margin: 0px auto 30px;
  max-width: 340px;
  @media (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    margin-bottom: 30px;
    font-size: 22px;
    line-height 30px;
    text-align: center;
  }
  @media (min-width: ${style((theme) => theme.breakpoints.sm)}px) {
    font-size: 22px;
    line-height: 30px;
    text-align: center;
  }
`

export const StyledText = styled.p`
  font-weight: bold;
  text-align: left;
  margin: 0;

  @media (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    margin-top: 0;
  }
`

export const GreenText = styled.span`
  color: ${theme.colors.green};
`

export const FormRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`

export const FormItem = styled.div`
  width: 100%;
  flex-basis: 100%;
  padding-bottom: 20px;

  .text-input {
    width: 100%;
  }
`

export const StyledPasswordInput = styled(PasswordInputV4)`
  :first-child > div > div {
    width: 340px;
    margin-bottom: 20px;
  }
`

export const StyledLabel = styled.div`
  font-size: 12px;
  color: ${style((theme) => theme.colors.slate)};
  margin-top: 2px;
`

export const Link = styled.a`
  text-decoration: underline;
  cursor: pointer;
  color: ${theme.colors.greenDark};
`
